import "../../assets/css/modal.css"
import { Modal } from "@mui/material"
import { ReactComponent as UserSearchIcon } from "../../assets/images/run-payroll/user-search.svg"
import React from "react"

const PayrollRecalculateMissingEmployeeModal = ({ open, handleClose, missedEmployees }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className="confirm-modal missing-employee">

        <div className="confirm-modal-wrapper">
          <div className="confirm-modal-icon-wrapper yellow">
            <UserSearchIcon className="confirm-modal-icon"/>
          </div>

          Missing Employee Data

          <div className="confirm-modal-subtitle missing-employee">
            <>
              It looks like some employee details are missing.

              Please update the information and then try recalculating the payroll.
            </>
          </div>

          <div className="missing-employee-list">
            List of missing employees:{" "}
          </div>

          <div className="missing-employee-list-container">
            {missedEmployees?.map((el, index) => (
                <div key={el.fedex_id} className="missing-employee-list-item">
                  {index + 1}. {el.first_name} {el.last_name} {el.fedex_id && `FedEx ID ${el.fedex_id}`}
                </div>
            ))}

            <div className="missing-employee-list-item" style={{marginTop: "1.5rem", color: "red"}}>
              Make sure you update{" "}
              <a
                  onClick={() => {
                    localStorage.setItem("employeesFilterBy", "3");
                    window.open("/employees", "_blank");
                  }}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
              >
                Employee Missed Info
              </a>{" "}
              for all your employees
            </div>

          </div>

          <div className="confirm-modal-btn-wrapper">
            <button className="confirm-modal-btn cancel" onClick={handleClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PayrollRecalculateMissingEmployeeModal
